import React from 'react';
import Layout from '../components/layout/Layout';
import RegistrarCalificacionInicial from '../components/calificaciones/RegistrarCalificacionInicial';
import RegistrarCalificacion from '../components/calificaciones/RegistrarCalificacion';
import CalificacionCualitativa from '../components/materias/CalificacionCualitativa';
import RegistroCalificacionComportamental from '../components/calificaciones/RegistrarCalificacionComportamental';

export const RegistrarCalificacionInicialPage = () => {
    return ( <Layout children={<RegistrarCalificacionInicial />} /> )
}

export const RegistrarCalificacionPage = () => {
    return ( <Layout children={<RegistrarCalificacion />} /> )
}

export const CalificaciónCualititativaPage = () => {
    return ( <Layout children={<CalificacionCualitativa />} /> )
}

export const CalificaciónComportamentalPage = () => {
    return ( <Layout children={<RegistroCalificacionComportamental />} /> )
}